import React, { forwardRef } from 'react';

interface EyeProps {
  classes?: string;
  style?: React.CSSProperties;
  forwardRef?: React.RefObject<HTMLElement>;
}

export const Eye = forwardRef<HTMLElement, EyeProps>(({ classes, style = {}, forwardRef: _ }, ref) => {
  return (
    <i ref={ref} className={`fa-regular fa-eye ${classes || ''}`} style={style}></i>
  );
});

Eye.displayName = 'Eye';
